var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlvotechBiosGenerics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#222222;}\n\t.st1{fill:#F69D25;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#F69D25;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\n\t.st4{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pipline"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "biosimilar"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "employees"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "network"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "generic-projects"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing-centers"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "key-growth"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "molecule"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "green"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "map"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "playground"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "microscope"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "basket"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "hand-pill"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "cosmetics"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "medical"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "dna_1_"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "investment"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "company"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "square-meter"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "bios-generics"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color_15_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.9,72.1c-17.9,0-32.5,14.5-32.5,32.5c0,17.9,14.5,32.5,32.5,32.5c17.9,0,32.5-14.5,32.5-32.5 C136.4,86.6,121.8,72.1,103.9,72.1z M113.8,110c-0.5,0.8-1,1.5-1.7,2.2c-2,2-4.7,3.2-7.6,3.2c-3.4,0-6.4-1.5-8.3-3.9 c-0.2-0.3-0.4-0.5-0.6-0.8c-1.2-1.7-1.9-3.8-1.9-6c0-0.7,0.1-1.5,0.2-2.2c0.1-0.7,0.4-1.4,0.6-2c0.5-1.3,1.3-2.4,2.3-3.4 c0,0,0,0,0.1-0.1c2-2,4.7-3.2,7.6-3.2c6,0,10.8,4.9,10.8,10.8C115.4,106.5,114.8,108.4,113.8,110z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.9,266.8c-17.9,0-32.5,14.5-32.5,32.5c0,17.9,14.5,32.5,32.5,32.5c17.9,0,32.5-14.5,32.5-32.5 C136.4,281.4,121.8,266.8,103.9,266.8z M103.9,310.1c-6,0-10.8-4.9-10.8-10.8c0-6,4.9-10.8,10.8-10.8s10.8,4.9,10.8,10.8 C114.7,305.3,109.9,310.1,103.9,310.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "neutral_21_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.6,
    y: 242.5,
    transform: "matrix(0.4472 -0.8944 0.8944 0.4472 -84.1005 354.3067)",
    className: "st0",
    width: 483.9,
    height: 5.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.4,66.8l0.3-10.8c-3.5-0.1-7.2-0.1-10.9-0.1h-10.8v10.8h10.8C118.4,66.7,122,66.7,125.4,66.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M215.3,77.7c-5.8-4.4-13-8.2-21.2-11.2l-3.7,10.1c7.2,2.7,13.5,5.9,18.4,9.7L215.3,77.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M224.2,163.3l10.3,3.4c2.4-7.2,3.9-15.3,4.5-23.5l-10.8-0.7C227.7,149.8,226.3,157,224.2,163.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.3,185.7l-3.8,0l-0.3,10.8l4.1,0c7.8,0,14.6-2.8,20.5-8.3l-7.4-7.9C210.5,183.9,206.3,185.7,201.3,185.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.3,119.7c-1.1-9-3.4-16.7-6.9-23.4l-9.6,5c2.9,5.5,4.8,12,5.7,19.7L238.3,119.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.1,115.4v-13.8H55.2v13.8c0,3.6,0.5,7,1.6,10.3l10.3-3.4C66.4,120.1,66.1,117.8,66.1,115.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79,136.5l-5.9,9.1c8.1,5.3,16.6,7.7,20.1,7.7l3.9,0l0.3-10.8l-4.1,0C91.9,142.4,85.6,140.8,79,136.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.5,60.4c-7-1.4-14.7-2.4-22.8-3.1l-1,10.8c7.8,0.7,15.2,1.7,21.8,3L171.5,60.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.6,70l-4.8-9.7c-5.9,2.9-14,8.2-19,16.8l9.3,5.5C72.8,76.2,79,72.2,83.6,70z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.5,155.5c7.2,1.4,14,3.6,20.1,6.5l4.6-9.8c-6.9-3.2-14.5-5.7-22.6-7.3L118.5,155.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.3,173.4c3.9,3.3,7.1,6.5,10,9.4c2.4,2.4,4.4,4.4,6.4,6.1l6.9-8.3c-1.8-1.5-3.6-3.3-5.7-5.4 c-3.1-3.1-6.5-6.5-10.7-10L156.3,173.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.7,224l-21.6-0.4c-35.8,0-64.9,29.1-64.9,64.9v129.8c0,23.9,19.4,43.3,43.3,43.3c21.6,0,64.9,0,64.9-64.9 c0-43.3,43.3-21.6,43.3-108.2C179.7,224.1,114.7,224,114.7,224z M137.9,348c-9.8,8.9-23.2,21.2-23.2,48.6 c0,43.3-21,43.3-43.3,43.3c-11.9,0-21.6-9.7-21.6-21.6V288.5c0-23.8,19.3-43.2,43.1-43.3l21.7,0.4c10.2,0.2,43.5,3.8,43.5,42.8 C158,329.6,148.3,338.6,137.9,348z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "115,261.9 115.2,256.5 114.5,251 93,250.6 91.8,250.6 92.7,261.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.2,
    y: 395.3,
    className: "st0",
    width: 10.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152,304.7l-10.8-0.9c-0.7,8.5-2.2,15-4.4,19.9l9.8,4.5C149.4,322.2,151.1,314.5,152,304.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.2,
    y: 350.5,
    className: "st0",
    width: 10.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.2,281.2c-1.4-9.8-5.6-17.5-12.6-22.7l-6.4,8.7c4.6,3.4,7.4,8.5,8.3,15.4L152.2,281.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.5,396.7c0,2.2,0,4.4-0.1,6.3l10.8,0.5c0.1-2.1,0.2-4.4,0.2-6.8c0-5.1,0.4-10,1.4-14.7l-10.6-2.1 C99,385.2,98.5,390.9,98.5,396.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.1,423.7l0.1,10.8c10-0.1,18.9-0.6,25-6.6l-7.5-7.8C90.7,423.1,85.2,423.6,76.1,423.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.2,
    y: 305.8,
    className: "st0",
    width: 10.8,
    height: 22.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.6,357.4l9.3,5.5c4.2-7.1,9.3-12.3,13.3-16l-7.4-7.9C119.3,343.2,113.5,349.2,108.6,357.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68,260.1c-6.6,5.8-10.9,13.8-12.3,22.4l10.7,1.7c1-6.2,4.1-11.9,8.8-16L68,260.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.7,28.8H93.1c-21.6,0-64.9,21.6-64.9,64.9v21.6c0,43.3,43.3,64.9,64.9,64.9c64.9,0,43.3,43.3,108.2,43.3 c43.3,0,64.9-43.3,64.9-86.6C266.2,50.4,201.3,28.8,114.7,28.8z M201.3,201.9c-23.5,0-29.2-5.7-38.8-15.3 c-11.8-11.8-28-28-69.4-28c-10.4,0-43.3-13-43.3-43.3V93.7c0-30.3,32.8-43.3,43.3-43.3h21.6c114.1,0,129.8,41.6,129.8,86.6 C244.6,159.4,235.5,201.9,201.3,201.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451.6,342.9l-5.2-10.4c2.2-3.4,3.8-7.2,3.8-11.5c0-4.3-1.6-8.1-3.8-11.5l5.2-10.4 c11.2-0.8,20.2-9.9,20.2-21.3c0-11.9-9.7-21.6-21.6-21.6c-11.9,0-21.6,9.7-21.6,21.6c0,4.3,1.6,8.1,3.8,11.5l-5.2,10.4 c-7.3,0.5-13.3,4.6-16.9,10.5h-6.7c-3.5-5.9-9.6-10-16.9-10.5l-5.2-10.4c2.2-3.4,3.8-7.2,3.8-11.5s-1.6-8.1-3.8-11.5l5.2-10.4 c11.2-0.8,20.2-9.9,20.2-21.3c0-11.9-9.7-21.6-21.6-21.6c-11.9,0-21.6,9.7-21.6,21.6c0,4.3,1.6,8.1,3.8,11.5l-5.2,10.4 c-7.3,0.5-13.3,4.6-16.9,10.5h-6.7c-3.5-5.9-9.6-10-16.9-10.5l-5.2-10.4c2.2-3.4,3.8-7.2,3.8-11.5s-1.6-8.1-3.8-11.5l5.2-10.4 c11.2-0.8,20.2-9.9,20.2-21.3c0-11.9-9.7-21.6-21.6-21.6s-21.6,9.7-21.6,21.6c0,4.3,1.6,8.1,3.8,11.5l-5.2,10.4 c-11.2,0.8-20.2,9.9-20.2,21.3c0,11.4,9,20.6,20.2,21.3l5.2,10.4c-2.2,3.4-3.8,7.2-3.8,11.5s1.6,8.1,3.8,11.5l-5.2,10.4 c-11.2,0.8-20.2,9.9-20.2,21.3c0,11.4,9,20.6,20.2,21.3l5.2,10.4c-2.2,3.4-3.8,7.2-3.8,11.5c0,4.3,1.6,8.1,3.8,11.5l-5.2,10.4 c-7.3,0.5-13.3,4.6-16.9,10.5h-6.7c-3.8-6.3-10.4-10.8-18.3-10.8c-11.9,0-21.6,9.7-21.6,21.6c0,4.3,1.6,8.1,3.8,11.5l-5.2,10.4 c-11.2,0.8-20.2,9.9-20.2,21.3c0,11.9,9.7,21.6,21.6,21.6s21.6-9.7,21.6-21.6c0-4.3-1.6-8.1-3.8-11.5l5.2-10.4 c7.3-0.5,13.3-4.6,16.9-10.5h6.7c3.5,5.9,9.6,10,16.9,10.5l5.2,10.4c-2.2,3.4-3.8,7.2-3.8,11.5c0,11.9,9.7,21.6,21.6,21.6 s21.6-9.7,21.6-21.6c0-11.4-9-20.6-20.2-21.3l-5.2-10.4c2.2-3.4,3.8-7.2,3.8-11.5s-1.6-8.1-3.8-11.5l5.2-10.4 c7.3-0.5,13.3-4.6,16.9-10.5h6.7c3.5,5.9,9.6,10,16.9,10.5l5.2,10.4c-2.2,3.4-3.8,7.2-3.8,11.5c0,11.4,9,20.6,20.2,21.3l5.2,10.4 c-2.2,3.4-3.8,7.2-3.8,11.5c0,11.9,9.7,21.6,21.6,21.6c11.9,0,21.6-9.7,21.6-21.6c0-11.4-9-20.6-20.2-21.3l-5.2-10.4 c2.2-3.4,3.8-7.2,3.8-11.5c0-11.4-9-20.6-20.2-21.3l-5.2-10.4c2.2-3.4,3.8-7.2,3.8-11.5c0-4.3-1.6-8.1-3.8-11.5l5.2-10.4 c7.3-0.5,13.3-4.6,16.9-10.5h6.7c3.5,5.9,9.6,10,16.9,10.5l5.2,10.4c-2.2,3.4-3.8,7.2-3.8,11.5c0,11.9,9.7,21.6,21.6,21.6 c11.9,0,21.6-9.7,21.6-21.6C471.8,352.8,462.8,343.6,451.6,342.9z M234.1,462.8c-6,0-10.8-4.8-10.8-10.8s4.8-10.8,10.8-10.8 s10.8,4.8,10.8,10.8S240.1,462.8,234.1,462.8z M254.8,418.3c-6,0-10.8-4.8-10.8-10.8c0-6,4.8-10.8,10.8-10.8 c6,0,10.8,4.8,10.8,10.8C265.6,413.5,260.8,418.3,254.8,418.3z M384.9,223.6c6,0,10.8,4.8,10.8,10.8c0,6-4.8,10.8-10.8,10.8 c-6,0-10.8-4.8-10.8-10.8C374,228.5,378.9,223.6,384.9,223.6z M363.2,267c6,0,10.8,4.8,10.8,10.8c0,6-4.8,10.8-10.8,10.8 s-10.8-4.8-10.8-10.8C352.4,271.8,357.2,267,363.2,267z M319.9,267c6,0,10.8,4.8,10.8,10.8c0,6-4.8,10.8-10.8,10.8 c-6,0-10.8-4.8-10.8-10.8C309,271.8,313.9,267,319.9,267z M319.9,180.3c6,0,10.8,4.8,10.8,10.8c0,6-4.8,10.8-10.8,10.8 c-6,0-10.8-4.8-10.8-10.8C309,185.1,313.9,180.3,319.9,180.3z M298.2,245.3c-6,0-10.8-4.8-10.8-10.8c0-6,4.8-10.8,10.8-10.8 c6,0,10.8,4.8,10.8,10.8C309,240.4,304.2,245.3,298.2,245.3z M298.2,331.9c-6,0-10.8-4.8-10.8-10.8c0-6,4.8-10.8,10.8-10.8 c6,0,10.8,4.8,10.8,10.8C309,327.1,304.2,331.9,298.2,331.9z M298.2,418.6c-6,0-10.8-4.8-10.8-10.8c0-6,4.8-10.8,10.8-10.8 c6,0,10.8,4.8,10.8,10.8C309,413.8,304.2,418.6,298.2,418.6z M319.9,440.3c6,0,10.8,4.8,10.8,10.8c0,6-4.8,10.8-10.8,10.8 c-6,0-10.8-4.8-10.8-10.8C309,445.1,313.9,440.3,319.9,440.3z M319.9,375.3c-6,0-10.8-4.8-10.8-10.8c0-6,4.8-10.8,10.8-10.8 c6,0,10.8,4.8,10.8,10.8C330.7,370.4,325.9,375.3,319.9,375.3z M345.3,353.4h-6.7c-3.5-5.9-9.6-10-16.9-10.5l-5.2-10.4 c2.2-3.4,3.8-7.2,3.8-11.5c0-4.3-1.6-8.1-3.8-11.5l5.2-10.4c7.3-0.5,13.3-4.6,16.9-10.5h6.7c3.5,5.9,9.6,10,16.9,10.5l5.2,10.4 c-2.2,3.4-3.8,7.2-3.8,11.5c0,4.3,1.6,8.1,3.8,11.5l-5.2,10.4C354.9,343.4,348.8,347.5,345.3,353.4z M363.2,375.3 c-6,0-10.8-4.8-10.8-10.8c0-6,4.8-10.8,10.8-10.8s10.8,4.8,10.8,10.8C374,370.4,369.2,375.3,363.2,375.3z M406.5,440.3 c6,0,10.8,4.8,10.8,10.8c0,6-4.8,10.8-10.8,10.8c-6,0-10.8-4.8-10.8-10.8C395.7,445.1,400.5,440.3,406.5,440.3z M384.9,396.9 c6,0,10.8,4.8,10.8,10.8c0,6-4.8,10.8-10.8,10.8c-6,0-10.8-4.8-10.8-10.8C374,401.8,378.9,396.9,384.9,396.9z M384.9,331.9 c-6,0-10.8-4.8-10.8-10.8c0-6,4.8-10.8,10.8-10.8c6,0,10.8,4.8,10.8,10.8C395.7,327.1,390.8,331.9,384.9,331.9z M449.8,267 c6,0,10.8,4.8,10.8,10.8c0,6-4.8,10.8-10.8,10.8c-6,0-10.8-4.8-10.8-10.8C439,271.8,443.9,267,449.8,267z M428.2,331.9 c-6,0-10.8-4.8-10.8-10.8c0-6,4.8-10.8,10.8-10.8c6,0,10.8,4.8,10.8,10.8C439,327.1,434.2,331.9,428.2,331.9z M449.8,375.3 c-6,0-10.8-4.8-10.8-10.8c0-6,4.8-10.8,10.8-10.8c6,0,10.8,4.8,10.8,10.8C460.7,370.4,455.8,375.3,449.8,375.3z"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "professional"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "capacity"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "award"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "pills"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "people"
  })));
}

export default SvgAlvotechBiosGenerics;